// eslint-disable-next-line @typescript-eslint/no-var-requires
import HomeView from '../views/HomeView.vue'
import { createRouter, createWebHistory } from 'vue-router'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type RouteRecordRaw = any

interface RouteMeta {
  title?: string
  description?: string
}
const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'Rwanda Kigali Selfdrive | Car Rental Kigali Rwanda',
      description: '#1 Car Rental in Rwanda. Rent Land Cruisers, SUVs & 4x4s for gorilla trekking & safaris. Full insurance, airport pickup, 24/7 support. Book now!'
    }
  },
  {
    path: '/cars',
    name: 'cars',
    component: () => import('../views/CarsView.vue'),
    meta: {
      title: 'Our Fleet - Rwanda Kigali Selfdrive | Land Cruisers, SUVs & More',
      description: 'Browse our premium car fleet. Land Cruisers, RAV4s, Hondas, and economy cars. All fully insured. Best rates in Rwanda.'
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue'),
    meta: {
      title: 'About Rwanda Kigali Selfdrive - Trusted Car Rental Partner',
      description: 'Learn about Rwanda Kigali Selfdrive. Years of experience in car rentals. Safe, reliable, and professional service.'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue'),
    meta: {
      title: 'Contact Us - Rwanda Kigali Selfdrive | +250 788 539 359',
      description: 'Contact Rwanda Kigali Selfdrive. Call or WhatsApp +250 788 539 359. Available 24/7 for inquiries and bookings.'
    }
  },
  {
    path: '/book',
    name: 'book',
    component: () => import('../views/BookView.vue'),
    meta: {
      title: 'Book a Car - Rwanda Kigali Selfdrive | Easy Online Booking',
      description: 'Book your car rental online. Simple process, flexible rates, instant confirmation. Reserve now.'
    }
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('../views/ServicesView.vue'),
    meta: {
      title: 'Our Services - Rwanda Kigali Selfdrive | Self-Drive & Driver Services',
      description: 'Explore our services: self-drive rentals, driver services, airport transfers, and safari car rentals.'
    }
  },
  {
    path: '/services/self-drive',
    name: 'self-drive',
    component: () => import('../components/service/SelfDriveService.vue'),
    meta: {
      title: 'Self-Drive Car Rental - Rwanda Kigali Selfdrive',
      description: 'Self-drive car rental in Rwanda. Explore at your own pace. Insurance included, GPS available, 24/7 support.'
    }
  },
  {
    path: '/services/driver-service',
    name: 'driver-service',
    component: () => import('../components/service/DriverService.vue'),
    meta: {
      title: 'Driver Service - Rwanda Kigali Selfdrive | Professional Drivers',
      description: 'Professional driver service in Rwanda. Experienced drivers, safe vehicles, affordable rates.'
    }
  },
  {
    path: '/services/long-term',
    name: 'long-term',
    component: () => import('../components/service/LongTermRental.vue'),
    meta: {
      title: 'Long-Term Car Rental - Rwanda Kigali Selfdrive | Monthly & Yearly',
      description: 'Long-term car rental in Rwanda. Monthly and yearly packages with special rates for businesses.'
    }
  },
  {
    path: '/services/airport-transfer',
    name: 'airport-transfer',
    component: () => import('../components/service/AirportTransfer.vue'),
    meta: {
      title: 'Airport Transfer - Rwanda Kigali Selfdrive | Kigali Airport Transport',
      description: 'Airport transfer from Kigali. Professional drivers, clean vehicles, meet & greet available.'
    }
  },
  {
    path: '/services/safari-car',
    name: 'safari-car',
    component: () => import('../components/service/SafariCarRental.vue'),
    meta: {
      title: 'Safari Car Rental - Rwanda Kigali Selfdrive | Gorilla & Wildlife',
      description: 'Safari car rental for gorilla trekking and wildlife. 4x4 vehicles for Volcanoes and Akagera.'
    }
  },
  {
    path: '/destinations',
    name: 'destinations',
    component: () => import('../views/DestinationsView.vue'),
    meta: {
      title: 'Rwanda Destinations - Rwanda Kigali Selfdrive | National Parks & More',
      description: 'Explore Rwanda destinations. Volcanoes, Akagera, Nyungwe, Lake Kivu, and more.'
    }
  },
  {
    path: '/destinations/volcanoes-national-park',
    name: 'volcanoes-national-park',
    component: () => import('../components/destinations/VolcanoesNationalPark.vue'),
    meta: {
      title: 'Volcanoes National Park - Rwanda Kigali Selfdrive | Gorilla Trekking',
      description: 'Volcanoes National Park. Gorilla trekking, stunning views, mountain trails.'
    }
  },
  {
    path: '/destinations/akagera-national-park',
    name: 'akagera-national-park',
    component: () => import('../components/destinations/AkageraNationalPark.vue'),
    meta: {
      title: 'Akagera National Park - Rwanda Kigali Selfdrive | Big Five Safari',
      description: 'Akagera National Park. See the Big Five on safari. Self-drive or guided tours.'
    }
  },
  {
    path: '/destinations/nyungwe-forest',
    name: 'nyungwe-forest',
    component: () => import('../components/destinations/NyungweForest.vue'),
    meta: {
      title: 'Nyungwe Forest - Rwanda Kigali Selfdrive | Chimpanzee Trekking',
      description: 'Nyungwe Forest. Chimpanzee trekking, rainforest walks, canopy adventures.'
    }
  },
  {
    path: '/destinations/lake-kivu',
    name: 'lake-kivu',
    component: () => import('../components/destinations/LakeKivu.vue'),
    meta: {
      title: 'Lake Kivu - Rwanda Kigali Selfdrive | Beach & Water Activities',
      description: 'Lake Kivu. Beautiful beaches, water sports, relaxation, and scenic drives.'
    }
  },
  {
    path: '/destinations/kigali-city',
    name: 'kigali-city',
    component: () => import('../components/destinations/KigaliCity.vue'),
    meta: {
      title: 'Kigali City Guide - Rwanda Kigali Selfdrive | Explore the Capital',
      description: 'Kigali city guide. Museums, restaurants, markets, cultural sites.'
    }
  },
  {
    path: '/destinations/musanze-caves',
    name: 'musanze-caves',
    component: () => import('../components/destinations/MusanzeCaves.vue'),
    meta: {
      title: 'Musanze Caves - Rwanda Kigali Selfdrive | Underground Adventure',
      description: 'Musanze Caves. Underground caves, lava tubes, and adventure activities.'
    }
  },
  {
    path: '/fleet',
    name: 'fleet',
    component: () => import('../views/FleetView.vue'),
    meta: {
      title: 'Car Fleet - Rwanda Kigali Selfdrive | Premium Vehicles',
      description: 'Our car fleet. Land Cruisers, SUVs, economy cars. Maintained and insured.'
    }
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import('../views/BlogView.vue'),
    meta: {
      title: 'Blog - Rwanda Kigali Selfdrive | Travel Tips & Guides',
      description: 'Read our blog for Rwanda travel tips, car rental guides, and destination advice.'
    }
  },
  {
    path: '/blog/gorilla-trekking-guide',
    name: 'gorilla-trekking-guide',
    component: () => import('../components/blog/GorillaTrekkingGuide.vue'),
    meta: {
      title: 'Gorilla Trekking Guide - Rwanda Kigali Selfdrive | Complete Guide',
      description: 'Complete gorilla trekking guide. What to expect, best practices, tips for success.'
    }
  },
  {
    path: '/blog/best-time-visit-rwanda',
    name: 'best-time-visit-rwanda',
    component: () => import('../components/blog/BestTimeVisitRwanda.vue'),
    meta: {
      title: 'Best Time to Visit Rwanda - Rwanda Kigali Selfdrive | Climate Guide',
      description: 'Best time to visit Rwanda. Weather, seasons, optimal times for activities.'
    }
  },
  {
    path: '/blog/akagera-national-park-guide',
    name: 'akagera-national-park-guide',
    component: () => import('../components/blog/AkageraNationalParkGuide.vue'),
    meta: {
      title: 'Akagera National Park Guide - Rwanda Kigali Selfdrive | Safari Tips',
      description: 'Akagera National Park guide. Safari tips, wildlife, accommodation.'
    }
  },
  {
    path: '/blog/car-rental-tips',
    name: 'car-rental-tips',
    component: () => import('../components/blog/CarRentalTips.vue'),
    meta: {
      title: 'Car Rental Tips - Rwanda Kigali Selfdrive | Rental Advice',
      description: 'Car rental tips for Rwanda. Budget advice, insurance, driving guide.'
    }
  },
  {
    path: '/blog/kigali-city-guide',
    name: 'kigali-city-guide',
    component: () => import('../components/blog/KigaliCityGuide.vue'),
    meta: {
      title: 'Kigali City Guide - Rwanda Kigali Selfdrive | Must-See Attractions',
      description: 'Kigali guide. Top attractions, restaurants, accommodation, things to do.'
    }
  },
  {
    path: '/blog/road-trip-planning',
    name: 'road-trip-planning',
    component: () => import('../components/blog/RoadTripPlanning.vue'),
    meta: {
      title: 'Road Trip Planning - Rwanda Kigali Selfdrive | Trip Guide',
      description: 'Road trip planning for Rwanda. Routes, stops, itineraries, tips.'
    }
  },
  {
    path: '/blog/car-rental-insurance',
    name: 'car-rental-insurance',
    component: () => import('../components/blog/CarRentalInsurance.vue'),
    meta: {
      title: 'Car Rental Insurance - Rwanda Kigali Selfdrive | Insurance Guide',
      description: 'Car rental insurance guide. Coverage options, CDW, liability insurance.'
    }
  },
  {
    path: '/blog/lake-kivu-guide',
    name: 'lake-kivu-guide',
    component: () => import('../components/blog/LakeKivuGuide.vue'),
    meta: {
      title: 'Lake Kivu Guide - Rwanda Kigali Selfdrive | Beach Activities',
      description: 'Lake Kivu guide. Beaches, resorts, water activities, things to do.'
    }
  },
  {
    path: '/blog/budget-travel-rwanda',
    name: 'budget-travel-rwanda',
    component: () => import('../components/blog/BudgetTravelRwanda.vue'),
    meta: {
      title: 'Budget Travel Rwanda - Rwanda Kigali Selfdrive | Budget Tips',
      description: 'Budget travel guide. Money-saving tips, affordable options, budget car rentals.'
    }
  },
  {
    path: '/blog/cultural-heritage-rwanda',
    name: 'cultural-heritage-rwanda',
    component: () => import('../components/blog/CulturalHeritageRwanda.vue'),
    meta: {
      title: 'Cultural Heritage Rwanda - Rwanda Kigali Selfdrive | Culture & History',
      description: 'Rwanda cultural heritage. Culture, history, traditions, cultural sites.'
    }
  },
  {
    path: '/about-rwanda',
    name: 'about-rwanda',
    component: () => import('../components/rwanda/AboutRwanda.vue'),
    meta: {
      title: 'About Rwanda - Rwanda Kigali Selfdrive | Country Information',
      description: 'Learn about Rwanda. Country information, geography, climate, facts.'
    }
  },
  {
    path: '/about-rwanda/national-parks',
    name: 'national-parks',
    component: () => import('../components/rwanda/NationalParks.vue'),
    meta: {
      title: 'Rwanda National Parks - Rwanda Kigali Selfdrive | Parks & Reserves',
      description: 'Rwanda national parks. Volcanoes, Akagera, Nyungwe, wildlife reserves.'
    }
  },
  {
    path: '/about-rwanda/culture-heritage',
    name: 'culture-heritage',
    component: () => import('../components/rwanda/CultureHeritage.vue'),
    meta: {
      title: 'Rwanda Culture & Heritage - Rwanda Kigali Selfdrive | Traditions',
      description: 'Rwanda culture and heritage. Traditions, customs, historical sites.'
    }
  },
  {
    path: '/about-rwanda/cities-towns',
    name: 'cities-towns',
    component: () => import('../components/rwanda/CitiesTowns.vue'),
    meta: {
      title: 'Rwanda Cities & Towns - Rwanda Kigali Selfdrive | Urban Destinations',
      description: 'Rwanda cities and towns. Kigali, Gisenyi, Ruhengeri, urban centers.'
    }
  },
  {
    path: '/about-rwanda/climate-best-time',
    name: 'climate-best-time',
    component: () => import('../components/rwanda/ClimateBestTime.vue'),
    meta: {
      title: 'Rwanda Climate & Best Time to Visit - Rwanda Kigali Selfdrive',
      description: 'Rwanda climate and best time to visit. Weather patterns, seasons, optimal times.'
    }
  },
  {
    path: '/about-rwanda/getting-around',
    name: 'getting-around',
    component: () => import('../components/rwanda/GettingAround.vue'),
    meta: {
      title: 'Getting Around Rwanda - Rwanda Kigali Selfdrive | Transport Guide',
      description: 'Getting around Rwanda. Transportation options, driving tips, roads.'
    }
  },
  {
    path: '/customer-photos',
    name: 'customer-photos',
    component: () => import('../views/CustomerPhotosView.vue'),
    meta: {
      title: 'Customer Photos - Rwanda Kigali Selfdrive | Customer Adventures',
      description: 'Customer photos from adventures in Rwanda. Real experiences from travelers.'
    }
  },
  {
    path: '/destinations/visit-uganda',
    name: 'visit-uganda',
    component: () => import('../views/VisitUganda.vue'),
    meta: {
      title: 'Visit Uganda - Rwanda Kigali Selfdrive | Uganda Travel Guide',
      description: 'Visit Uganda guide. Car rentals for Uganda, destinations, travel tips.'
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFound.vue'),
    meta: {
      title: 'Page Not Found - Rwanda Kigali Selfdrive',
      description: 'The page you are looking for does not exist.'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior (to: any, from: any, savedPosition: any) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  }
})

// ⭐ CRITICAL: Update document title and meta tags before each route change
router.beforeEach((to: any, from: any, next: any) => {
  // Update page title
  if (to.meta.title) {
    document.title = to.meta.title

    // Also update the meta name="title" tag
    let titleTag = document.querySelector('meta[name="title"]')
    if (!titleTag) {
      titleTag = document.createElement('meta')
      titleTag.setAttribute('name', 'title')
      document.head.appendChild(titleTag)
    }
    titleTag.setAttribute('content', to.meta.title)
  }

  // Update meta description
  if (to.meta.description) {
    let descriptionTag = document.querySelector('meta[name="description"]')
    if (!descriptionTag) {
      descriptionTag = document.createElement('meta')
      descriptionTag.setAttribute('name', 'description')
      document.head.appendChild(descriptionTag)
    }
    descriptionTag.setAttribute('content', to.meta.description)
  }

  // Update Open Graph tags for social sharing
  if (to.meta.title) {
    updateMetaTag('og:title', to.meta.title)
  }
  if (to.meta.description) {
    updateMetaTag('og:description', to.meta.description)
  }

  // Update Twitter Card tags
  if (to.meta.title) {
    updateMetaTag('twitter:title', to.meta.title)
  }
  if (to.meta.description) {
    updateMetaTag('twitter:description', to.meta.description)
  }

  // Update canonical URL
  updateCanonicalURL(to.path)

  next()
})

// Helper function to update Open Graph and Twitter meta tags
function updateMetaTag (property: string, content: string) {
  let tag = document.querySelector(`meta[property="${property}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('property', property)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

// Helper function to update canonical URL
function updateCanonicalURL (path: string) {
  let canonicalTag = document.querySelector('link[rel="canonical"]')
  if (!canonicalTag) {
    canonicalTag = document.createElement('link')
    canonicalTag.setAttribute('rel', 'canonical')
    document.head.appendChild(canonicalTag)
  }
  const baseUrl = 'https://rwandakigaliselfdrive.com'
  const fullUrl = path === '/' ? baseUrl : `${baseUrl}${path}`
  canonicalTag.setAttribute('href', fullUrl)
}

export default router
